import classes from "../AdminTool/AdminTools.module.css";
import React, {useEffect, useState} from "react";
import Aux from "../../../hoc/Auxiliary";
import SetupQueriesButton from "./PersistES/SetupQueriesButton";
import CloseDCButton from "./CloseDCButton/CloseDCButton";
import {isPermanentlyClosed} from "../../../api/dataCollection/dataCollection-status";
import ReopenDCButton from "./ReopenDC/ReopenDCButton";
import DynamicActions from "./DynamicActions/DynamicActions";
import {canRetrieveAndExecuteActions} from "../../../api/authorization/rules";

const AdminTool = (props) => {
    const [adminBtnDisabled, setAdminBtnDisabled] = useState(false);


    useEffect(() => {
        setAdminBtnDisabled(isPermanentlyClosed(props.dataCollection.status))

    }, [])

    return (

        <Aux>
            <div className={classes.tool}>
                <CloseDCButton dataCollection={props.dataCollection}
                               setAdminToolsButtonsDisabled={setAdminBtnDisabled}/>
                <SetupQueriesButton dataCollectionId={props.dataCollection.id}
                                    dataCollectionName={props.dataCollection.name}
                                    marketNodes={props.marketNodes}
                                    persistDisabled={props.persistDisabled}
                                    setReload={props.setReload}
                                    reload={props.reload}
                                    dataCollectionStatus={props.dataCollection.status}
                                    adminToolsButtonsDisabled={adminBtnDisabled}/>
                <ReopenDCButton dataCollection={props.dataCollection} marketNodes={props.marketNodes}/>
                <div className="mr-2 ">
                    <DynamicActions
                        fetchActions={props.fetchActions}
                        actions={props.actions}
                        dataCollection={props.dataCollection}
                        visible={canRetrieveAndExecuteActions()}
                        disabled={props.persistDisabled}
                    />
                </div>
            </div>
        </Aux>

    )

}
export default AdminTool;
